import React from 'react';

import { useCopywriterDispatch } from './CopywriterContext';

const Opener = ({ children }) => {

  const dispatch = useCopywriterDispatch();

  return React.cloneElement(children, { onClick: () => dispatch({ type: 'toggle' }) });
};

export default Opener;
